import React from 'react';

export default function ProductCardSkeleton() {
  return (
    <div className="relative flex flex-col justify-between bg-white rounded-2xl p-3 shadow-[0_4px_25px_rgba(0,0,0,0.03)] border border-gray-100 w-full overflow-hidden select-none">
      {/* Top Floating Row (Discount Badge & Wishlist Button Skeleton) */}
      <div className="absolute top-3 left-3 right-3 z-10 flex items-start justify-between pointer-events-none">
        <div className="pointer-events-auto flex flex-col items-start gap-1">
          <div className="h-4 w-12 rounded-md shimmer-effect" />
        </div>
        <div className="pointer-events-auto w-8 h-8 rounded-full bg-white shadow-[0_3px_12px_rgba(0,0,0,0.08)] border border-gray-100/50 flex items-center justify-center mt-[-7px] mr-[-4px]">
          <div className="w-3.5 h-3.5 rounded-full shimmer-effect" />
        </div>
      </div>

      {/* Main Image Section (Aspect-square 1:1 matching ProductCard) */}
      <div className="relative w-full aspect-square flex items-center justify-center overflow-hidden mb-0 p-2">
        <div className="w-[85%] h-[85%] rounded-2xl shimmer-effect flex items-center justify-center">
          <span className="font-display font-black text-gray-300/40 text-xl tracking-widest italic select-none">RK</span>
        </div>
      </div>

      {/* Product Details Section */}
      <div className="flex-grow flex flex-col justify-between min-w-0">
        <div className="flex flex-col min-w-0 mb-0.5">
          {/* Badge Placeholder */}
          <div className="h-3 w-16 rounded-full shimmer-effect mb-1" />

          {/* Product Title Placeholders (Matching min-h-[36px] md:min-h-[44px]) */}
          <div className="min-h-[36px] md:min-h-[44px] flex flex-col justify-center space-y-1 overflow-hidden">
            <div className="h-3.5 md:h-4 w-11/12 rounded-md shimmer-effect" />
            <div className="h-3.5 md:h-4 w-2/3 rounded-md shimmer-effect" />
          </div>

          {/* Net Quantity / Unit Placeholder */}
          <div className="h-3 w-12 rounded-md shimmer-effect mt-1" />
        </div>

        {/* Footer Section (Price & Add CTA aligned) */}
        <div className="flex items-end justify-between gap-1 mt-auto pt-1">
          <div className="flex flex-col min-w-0">
            <div className="flex items-center gap-1 flex-wrap min-w-0">
              <div className="h-5 md:h-6 w-14 rounded-md shimmer-effect" />
            </div>
          </div>

          {/* Action Button Placeholder (Matching ProductCard w-8 h-8 md:w-9 md:h-9 rounded-[8px]) */}
          <div className="flex items-center justify-end shrink-0">
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-[8px] shimmer-effect" />
          </div>
        </div>
      </div>
    </div>
  );
}



